import { OFFDAYS } from "../shared/tagTypes";
import { baseApi } from "./base";

const offdayApi = baseApi
    .enhanceEndpoints({
        addTagTypes: [OFFDAYS],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getOffdays: builder.query({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/off-days`,
                    params: {
                        ...(payload.serviceCenterId && { serviceCenterId: payload.serviceCenterId }),
                        ...(payload.startFrom && { startFrom: payload.startFrom }),
                        ...(payload.endTo && { endTo: payload.endTo }),
                    }
                }),
                providesTags: [OFFDAYS],
            }),
            getOffday: builder.query({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/off-days/${payload.id}`
                }),
                providesTags: [OFFDAYS],
            }),
            createOffday: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/off-days`,
                    method: "POST",
                    body: payload.body,
                }),
                invalidatesTags: [OFFDAYS],
            }),
            updateOffday: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/off-days/${payload.id}`,
                    method: "PUT",
                    body: payload.body,
                }),
                invalidatesTags: [OFFDAYS],
            }),
            deleteOffday: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/off-days/${payload.id}`,
                    method: "DELETE",
                }),
                invalidatesTags: [OFFDAYS],
            })
        }),

        overrideExisting: false,
    });

export const {
    useGetOffdaysQuery,
    useLazyGetOffdaysQuery,
    useGetOffdayQuery,
    useLazyGetOffdayQuery,
    useCreateOffdayMutation,
    useUpdateOffdayMutation,
    useDeleteOffdayMutation
} = offdayApi;
